import { TripStopResponse } from "types/trip.types";
import UnknownPlaceMarker from "./UnknownPlaceMarker";
import { ColorSpectrums } from "types/ColorSpectrum";

interface unassignedStopsProps {
  stops: TripStopResponse[];
  onStopClick?: (stop: TripStopResponse) => void;
  onAction?: (action: string, params?: any) => void;
}
export default function UnassignedStops({
  stops,
  onStopClick,
  onAction,
}: unassignedStopsProps) {
  return (
    <>
      {stops.map((stop, index) => (
        <UnknownPlaceMarker
          key={index}
          place={stop.place as any}
          stopIndex={index}
          color={ColorSpectrums.highContrast}
          highlight={false}
          label="&bull;"
          tooltip={stop.orders?.map((o) => o.externalId).join(", ")}
          tripId={0}
          onAction={(action, params) => {
            if (onAction) onAction(action, params);
            else if (action === "map-place-click") {
              onStopClick && onStopClick(stop);
            }
          }}
        />
      ))}
    </>
  );
}
